













import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import skyconText from '@/utils/skyconText'
export default Vue.extend({
    props: ['longitude', 'latitude'],
    computed: {
        lngLat(): any {
            const { longitude, latitude } = this
            return { longitude, latitude }
        },
    },
    watch: {
        lngLat() {
            this.getData()
        },
    },
    data() {
        return {
            data: {},
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getData() {
            const url = `/v2.5/Qu1kUDHidwJHZoNF/${this.lngLat.longitude},${this.lngLat.latitude}/hourly`
            request.get(url).then((result) => {
                // console.log(result.result.hourly)
                const tempData = result.result.hourly.temperature.slice(0, 24)
                const skycon = result.result.hourly.skycon.slice(0, 24)
                // const preData = result.result.hourly.precipitation.slice(0, 24)
                const hoursData = tempData.map((e: any) => {
                    return {
                        tem: e.value.toFixed(1),
                        time: e.datetime.split('T')[1].split('+')[0],
                    }
                })
                hoursData.map((e: any) => {
                    skycon.map((k: any) => {
                        if (e.time === k.datetime.split('T')[1].split('+')[0]) {
                            e.imgUrl = `/static/weatherIcon/${k.value}.png`
                            e.skyconText = skyconText.skyconText(k.value)
                        }
                    })
                })
                // console.log(hoursData)
                this.data = hoursData.slice(0, 24)
            }).catch((err) => {
                console.log(err)
                this.$Message.warning(err)
            })
        },
    },
})
